import React, { createContext, PropsWithChildren, useContext } from 'react';
import { FormatPrice, formatPrice } from '@ibe/services';

export type ExternalFormatPriceContextProps = FormatPrice | undefined;

export const ExternalFormatPriceContext = createContext<
  ExternalFormatPriceContextProps | undefined
>(undefined);

export const useExternalFormatPrice = (): FormatPrice => {
  const externalFormatPrice = useContext<ExternalFormatPriceContextProps>(
    ExternalFormatPriceContext
  );
  return externalFormatPrice || formatPrice;
};

const ExternalFormatPrice = (
  props: PropsWithChildren<{ externalFormatPrice?: FormatPrice }>
): JSX.Element => {
  const { children, externalFormatPrice } = props;

  return (
    <ExternalFormatPriceContext.Provider value={externalFormatPrice}>
      {children}
    </ExternalFormatPriceContext.Provider>
  );
};

export default ExternalFormatPrice;
